<template>
	<footer
		class="flex flex-col md:flex-row md:items-center justify-between gap-5 md:gap-6 px-4 sm:px-6 md:px-10 py-5 border-t transition-colors duration-300 overflow-hidden"
		:class="
			isLight
				? 'border-[#d0ede8] bg-[#e4f4f0]'
				: 'border-white/[0.06] bg-[#0f1f1c]'
		">
		<!-- Logo -->
		<span
			class="font-display font-extrabold text-lg tracking-tight text-center md:text-left"
			:class="isLight ? 'text-[#0f1f1c]' : 'text-white'">
			trekko<span :class="isLight ? 'text-[#1a9b8a]' : 'text-[#a8d5cc]'"
				>.</span
			>
		</span>

		<!-- Night / Light mode toggle -->
		<div
			class="flex w-full sm:w-auto justify-center gap-0.5 p-1 rounded-full border transition-colors duration-300"
			:class="
				isLight ? 'bg-[#e4f4f0] border-[#d0ede8]' : 'bg-white/6 border-white/10'
			">
			<!-- Night -->
			<button
				@click="!isLight ? null : $emit('toggle-mode')"
				class="flex items-center justify-center gap-1.5 px-3 sm:px-4 py-2 rounded-full text-xs font-medium transition-all duration-200 min-h-[40px]"
				:class="
					!isLight
						? 'bg-white/10 text-white shadow-sm'
						: 'text-[#6b8f89] hover:text-[#0f1f1c]'
				">
				<svg
					width="13"
					height="13"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round">
					<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
				</svg>
				{{ $t("footer.night") }}
			</button>

			<!-- Light -->
			<button
				@click="isLight ? null : $emit('toggle-mode')"
				class="flex items-center justify-center gap-1.5 px-3 sm:px-4 py-2 rounded-full text-xs font-medium transition-all duration-200 min-h-[40px]"
				:class="
					isLight
						? 'bg-white text-[#0d6b5e] shadow-sm'
						: 'text-[#a8d5cc] hover:text-white'
				">
				<svg
					width="13"
					height="13"
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round">
					<circle cx="12" cy="12" r="5" />
					<line x1="12" y1="1" x2="12" y2="3" />
					<line x1="12" y1="21" x2="12" y2="23" />
					<line x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
					<line x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
					<line x1="1" y1="12" x2="3" y2="12" />
					<line x1="21" y1="12" x2="23" y2="12" />
					<line x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
					<line x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
				</svg>
				{{ $t("footer.light") }}
			</button>
		</div>

		<!-- Links -->
		<div
			class="flex flex-col sm:flex-row items-center justify-center md:justify-end gap-2 sm:gap-5 text-xs sm:text-sm text-center"
			:class="isLight ? 'text-[#6b8f89]' : 'text-[#a8d5cc]'">
			<a
				href="/privacy-policy"
				class="no-underline transition-colors duration-200 break-words"
				:class="isLight ? 'hover:text-[#0f1f1c]' : 'hover:text-white'">
				{{ $t("footer.terms") }}
			</a>
			<a
				href="/contact"
				class="no-underline transition-colors duration-200 break-words"
				:class="isLight ? 'hover:text-[#0f1f1c]' : 'hover:text-white'">
				{{ $t("footer.contact") }}
			</a>
		</div>
	</footer>
</template>

<script>
export default {
	name: "FooterComponent",
	props: { isLight: Boolean },
	emits: ["toggle-mode"],
	data() {
		return { currentYear: new Date().getFullYear() };
	},
};
</script>

<style scoped>
footer * {
	min-width: 0;
}
</style>
